module.exports = __webpack_public_path__ + "img/united-states-of-america.936feee6.svg";